import { Navigate, Outlet } from 'react-router-dom';
import { getRefreshToken, useAuth } from '../context/AuthContext';
import { config } from 'config';

interface ProtectedRouteProps {
  landingRoute: string;
}

const redirectToOneIoLogin = (refreshToken: string) => {
  const redirectTo = refreshToken ? config.OneIOLoginURLWithoutConsent : config.OneIOLoginURL;

  window.location.replace(redirectTo);

  return null;
};

function ProtectedRoute({ landingRoute }: ProtectedRouteProps) {
  const { isAuthenticated } = useAuth();
  const refreshToken = getRefreshToken();

  return isAuthenticated ? (
    <Outlet />
  ) : !config.useOneIOLogin ? (
    <Navigate to={landingRoute} replace />
  ) : (
    redirectToOneIoLogin(refreshToken ?? '')
  );
}

export default ProtectedRoute;
